export const LOAD_PACKAGES = 'App/Packages::LOAD_PACKAGES';
export const CHOOSE_PACKAGE = 'App/Packages::CHOOSE_PACKAGE';
